import { Injectable } from '@angular/core';
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class MomentService {

  constructor() {
    moment.locale('es');
  }

  public moment(date: any, formatDate?:string) {
    return formatDate ? moment(date,formatDate) : moment(date);
  }
  public format(date: any, format: string, formatDate?: string) {
    let m = formatDate ? moment(date, formatDate) : moment(date); 
    let dateFormat = m.format(format);
    return dateFormat;
  }
  public add(date: any, format: string, amount: number, unit: any) {
    let dateFormat = moment(date).add(amount,unit).format(format);
    return dateFormat;
  }
  public subtract(date: any, format: string, amount: number, unit: any) {
    let dateFormat = moment(date).subtract(amount,unit).format(format);
    return dateFormat;
  }
  public startMonth(date?: any, format?: string) {
    let dateFormat = moment(date).clone().startOf('month').format(format ? format : 'YYYY-MMMM-DD');
    return dateFormat;
  }
  public endMonth(date?: any, format?: string) {
    let dateFormat = moment(date).clone().endOf('month').format(format ? format : 'YYYY-MMMM-DD 11:59:59');
    return dateFormat;
  }
  public getLastDays(numberOfDays: number, date?: any) {
    const current = (date ? moment(date) : moment()); //.startOf('week').weekday(1);
    let days = [];
    while(numberOfDays > 0) {
      days.push({
        dayName: current.format('dddd'),
        dayNameShort: current.format('ddd'),
        dayNumber: current.date(),
        dayDateFormat: current.format("YYYY-MM-DD"),
        dayDateFormatNumber: current.format("YYYYMMDD")
      });
      current.subtract(1,"day");
      numberOfDays--;
    }
    return days;
  }

}
